// extracted by mini-css-extract-plugin
module.exports = {"BundleInfo":"BundleInfoUI_BundleInfo__di6Kp"};